import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import { BsJournalCode } from "react-icons/bs";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { CountUp } from "use-count-up";

import { Button } from "../Components/Button/Button";
import { FadeInLeft, Reveal } from "../Components/Reveal/Reveal";
import { Banner } from "../Components/Banner/Banner";
import { useInView } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { ContactSection } from "../Components/ContactSection/ContactSection";

import { HiOutlineLightBulb } from "react-icons/hi";
import { TfiRulerPencil } from "react-icons/tfi";
import { GoCodeSquare } from "react-icons/go";
import { TbBrandSpeedtest } from "react-icons/tb";
import { VscFeedback } from "react-icons/vsc";
import { HiOutlineRocketLaunch } from "react-icons/hi2";

import { BsHddNetwork } from "react-icons/bs";

import { LiaPeopleCarrySolid } from "react-icons/lia";

import { useNavigate } from "react-router-dom";
import { IoStorefrontOutline } from "react-icons/io5";
import { AiOutlineAppstoreAdd } from "react-icons/ai";

export const Home = (prop) => {
  const navigate = useNavigate();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    if (isInView) {
      setIsCounting(true);
    }
  }, [isInView]);

  useEffect(() => {
    window.scrollTo(0, 0);
    prop.setSelectedPage("/");
  }, []);

  useEffect(() => {});

  return (
    <>
      <Helmet>
        <title>
          Home - DataDept | Expert Software Solutions for Businesses
        </title>
        <meta
          name="description"
          content="Elevate your business with our tailored software solutions, SaaS, and cloud services. Transform into a market leader with innovation and excellence."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <Banner setIsOpen={prop.setIsOpen} />
      <section className="how-we-work container-style">
        <Reveal>
          <div className="content-sizing how-we-work-wrapper">
            <FadeInLeft delay={0.3}>
              <div className="box-content-how-we-work">
                <div className="left-side-info-how-we-work">
                  <div>
                    <span className="small-tag">Work Model</span>
                    <h2>Our Process</h2>
                    <p>
                      Discover how we turn ideas into innovative solutions with
                      our streamlined and client-centric approach.
                    </p>
                  </div>

                  <Button onClick={() => navigate("about-us")}>
                    Learn More
                  </Button>
                </div>
              </div>
            </FadeInLeft>

            <div class="how-we-do-right-content">
              <div class="how-we-do-items d-flex align-items-center justify-content-center">
                <Reveal delay={0.35}>
                  <div class="how-we-do-card">
                    <div class="line-shape"></div>
                    <div class="how-we-do-icon">
                      <HiOutlineLightBulb />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Consultation</h3>
                      <p>Ideas</p>
                    </div>
                  </div>
                </Reveal>
                <Reveal delay={0.4}>
                  <div class="how-we-do-card">
                    <div class="circle-shape"></div>
                    <div class="line-shape"></div>
                    <div class="how-we-do-icon">
                      <TfiRulerPencil />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Product</h3>
                      <p>Design</p>
                    </div>
                  </div>
                </Reveal>
                <Reveal delay={0.45}>
                  <div class="how-we-do-card">
                    <div class="circle-shape"></div>
                    <div class="line-shape right-going-to-left"></div>
                    <div class="how-we-do-icon">
                      <GoCodeSquare />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Development</h3>
                      <p>Coding</p>
                    </div>
                  </div>
                </Reveal>
              </div>

              <div class="how-we-do-items d-flex align-items-center justify-content-center">
                <Reveal delay={0.5}>
                  <div class="how-we-do-card right-side-dot">
                    <div class="circle-shape"></div>
                    <div class="line-shape left-going-to-right"></div>
                    <div class="how-we-do-icon">
                      <VscFeedback />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Client Review</h3>
                      <p>Feedback</p>
                    </div>
                  </div>
                </Reveal>
                <Reveal delay={0.55}>
                  <div class="how-we-do-card right-side-dot">
                    <div class="circle-shape"></div>
                    <div class="line-shape middle-aero"></div>
                    <div class="how-we-do-icon">
                      <TbBrandSpeedtest />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Quality Assurance</h3>
                      <p>Testing</p>
                    </div>
                  </div>
                </Reveal>
              </div>

              <div class="how-we-do-items d-flex align-items-center justify-content-center">
                <Reveal delay={0.45}>
                  <div class="how-we-do-card">
                    <div class="circle-shape"></div>
                    <div class="how-we-do-icon">
                      <HiOutlineRocketLaunch />
                    </div>
                    <div class="how-we-do-content">
                      <h3>Product Launch</h3>
                      <p>User Adoption</p>
                    </div>
                  </div>
                </Reveal>
              </div>
            </div>
            <img
              src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
              alt="Shape"
              class="slide-left"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>

      <section className="what-we-offer container-style">
        <div className="content-sizing what-we-offer-wrapper">
          <div className="top-heading-what-we-offer">
            <div>
              <span className="small-tag">WHAT WE’RE OFFERING</span>
              <h2>Empower your business with tailored IT solutions.</h2>
            </div>

            <p>
              From bespoke software development to dynamic web applications, CRM
              software, and comprehensive IT support, we provide a holistic
              approach to meeting your technology needs.
            </p>
          </div>

          <ul className="service-list-we-offer">
            <Reveal delay="0.2">
              <li>
                <AiOutlineAppstoreAdd />

                <h3>Software Development</h3>
                <p>Making tailored software solutions for your business</p>
              </li>
            </Reveal>
            <Reveal delay="0.3">
              <li>
                <IoStorefrontOutline />
                <h3>E-commerce</h3>
                <p>Tailored solutions for your online success. </p>
              </li>
            </Reveal>
            <Reveal delay="0.4">
              <li>
                <LiaPeopleCarrySolid />
                <h3>CRM Solutions</h3>
                <p>Efficient customer relationship management. </p>
              </li>
            </Reveal>
            <Reveal delay="0.5">
              <li>
                <BsJournalCode />
                <h3>Web Applications</h3>
                <p>Dynamic solutions for web-based needs. </p>
              </li>
            </Reveal>
            <Reveal delay="0.6">
              <li>
                <BsHddNetwork />
                <h3>IT Support</h3>
                <p>Expert, reliable support for your technology.</p>
                {/* <span>Free!</span> */}
              </li>
            </Reveal>
          </ul>
        </div>
      </section>

      <section className="consulting container-style">
        <div className="content-sizing consulting-wrapper">
          <Reveal delay={0.5}>
            <div className="left-side-consult">
              <span className="small-tag">CONSULTING EXCELLENCE</span>
              <h2>Guiding our clients to success. </h2>
              <p>
                Our consulting process starts with a comprehensive evaluation of
                your existing IT infrastructure, workflows, and challenges.
              </p>
              <ul>
                <li>
                  <IoIosCheckmarkCircle /> 24/7 Full-Service Support
                </li>
                <li>
                  <IoIosCheckmarkCircle /> Immediate Response
                </li>
                <li>
                  <IoIosCheckmarkCircle /> Easy to Approach us
                </li>
              </ul>
            </div>
          </Reveal>

          <div className="right-content">
            <div class="about-timeline">
              <div className="single-box-item-consulting right-consulting top-consulting">
                <span>01</span>
                <Reveal delay={0.1}>
                  <div className="item-wrapper-consulting">
                    <h2>Discovery and Analysis</h2>
                    <p>
                      Perform an analysis of the client's existing IT systems.
                    </p>
                    <img
                      decoding="async"
                      src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
                      alt="Shape"
                      class="slide-left"
                      loading="lazy"
                    />
                  </div>
                </Reveal>
              </div>

              <div className="single-box-item-consulting left-consulting middle-consulting">
                <span>02</span>
                <Reveal delay={0.2}>
                  <div className="item-wrapper-consulting">
                    <h2>Tailored Solutions</h2>
                    <p>
                      Tailor IT solutions precisely to meet identified needs.
                    </p>
                    <img
                      decoding="async"
                      src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
                      alt="Shape"
                      class="slide-left"
                      loading="lazy"
                    />
                  </div>
                </Reveal>
              </div>

              <div className="single-box-item-consulting right-consulting bottom-consulting">
                <span>03</span>
                <Reveal delay={0.3}>
                  <div className="item-wrapper-consulting">
                    <h2>Deployment and Support</h2>
                    <p>
                      Ensure smooth operation with post-implementation support.
                    </p>
                    <img
                      decoding="async"
                      src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
                      alt="Shape"
                      class="slide-left"
                      loading="lazy"
                    />
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="how-we-work container-style">
        <Reveal>
          <div className="content-sizing stats-numbers">
            <Reveal>
              <div className="header-info-stats-box">
                <span className="small-tag">EXPERIENCE</span>
                <h2>Our statistics based on past experiences.</h2>
              </div>
            </Reveal>

            <ul className="stat-score-list" ref={ref}>
              <li className="single-stat-score-item">
                <h3>
                  <CountUp isCounting={isCounting} end={10} duration={1.5} />+{" "}
                  <h4>Years</h4>
                </h3>
                <p>Field Experience</p>
              </li>
              <li className="single-stat-score-item">
                <h3>
                  <CountUp isCounting={isCounting} end={100} duration={2} />+{" "}
                  <h4>Projects</h4>
                </h3>
                <p>Done Around The World</p>
              </li>
              <li className="single-stat-score-item">
                <h3>
                  <CountUp isCounting={isCounting} end={99} duration={2} />%
                </h3>
                <p>Client Satisfaction</p>
              </li>
              <li className="single-stat-score-item">
                <h3>
                  <CountUp isCounting={isCounting} end={2} duration={1} />{" "}
                  <h4>Min</h4>
                </h3>
                <p>Response Time</p>
              </li>
            </ul>
            <img
              decoding="async"
              src="https://wpriverthemes.com/synck/wp-content/uploads/2023/11/bg-shape-1-1.svg"
              alt="Shape"
              class="slide-left"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>
    </>
  );
};
